import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProductCard from '../ProductCard/ProductCard';
import Layout from '../Layout/Layout';
import './CategoryProducts.css';
import { neo4jService } from '../../services/neo4jService';
// import { menu_categories } from '../../misc/objs';

const CategoryProducts = () => {
  const { subcategory: urlSubcategory } = useParams();
  const subcategory = decodeURIComponent(urlSubcategory)
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchProducts() {
      try {
        setLoading(true);
        const fetchedProducts = await neo4jService.getProductsByCategory(subcategory);
        setProducts(fetchedProducts);
        setError(null);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products');
      } finally {
        setLoading(false);
      }
    }

    fetchProducts();
  }, [subcategory]);

  if (loading) {
    return (
      <Layout>
        <div className="loading">Loading products...</div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="error">{error}</div>
      </Layout>
    );
  }
  
  return (
    <Layout>
      <div className="category-products-section">
        <div className="category-products-header">
          <h2 className="section-title">{subcategory}</h2>
          <p className="product-count">{products.length} products found</p>
        </div>

        <div className="products-grid">
          {products.length === 0 ? (
            <div className="no-products">
              <p>No products found in {subcategory}.</p>
            </div>
          ) : (
            products.map((product) => (
              <ProductCard
                key={product.id}
                id={product.id}
                name={product.name}
                price={product.price}
                brand={product.brand}
                condition={product.condition}
                description={product.description}
                image={product.main_image}
                rating={product.rating}
                reviewsCount={product.reviewsCount}
                inStock={product.inStock}
                qty_instock={product.qty_instock}
                originalPrice={product.originalPrice}
                tag={product.tag}
                isNew={product.isNew}
              />
            ))
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CategoryProducts;
